export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export default SortDirection;
